export default "__VITE_ASSET__D2EoZemd__"